import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=16edf152&scoped=true"
import script from "./timeline.vue?vue&type=script&lang=js"
export * from "./timeline.vue?vue&type=script&lang=js"
import style0 from "./timeline.vue?vue&type=style&index=0&id=16edf152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16edf152",
  null
  
)

export default component.exports